/* A dark room for the photograph: neutral black so the metal reads true, with the
   tag's fixed cream for the few controls. The page behind fades as you pull down. */
.viewer {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: grid;
  grid-template-rows: auto 1fr;
  background: rgb(0 0 0 / calc(0.97 * var(--dim, 1)));
  color: var(--qr-paper);
  animation: viewer-in var(--duration-ui) var(--ease-out) both;
}

@keyframes viewer-in {
  from {
    opacity: 0;
  }
}

.bar {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  padding: calc(var(--space-2) + env(safe-area-inset-top)) var(--space-2) var(--space-2);
  opacity: var(--dim, 1);
}

.count {
  font-size: var(--text-caption);
  font-variant-numeric: tabular-nums;
  opacity: 0.8;
}

.control {
  display: grid;
  place-items: center;
  inline-size: var(--touch);
  block-size: var(--touch);
  border-radius: var(--radius-pill);
  color: inherit;
  background: rgb(0 0 0 / 0.35);
}

.control:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.control:disabled {
  opacity: 0.3;
}

/* The page must not pinch or scroll under a gesture meant for the photo. */
.stage {
  position: relative;
  min-block-size: 0;
  display: grid;
  place-items: center;
  overflow: hidden;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  padding-block-end: env(safe-area-inset-bottom);
}

.photo {
  max-inline-size: 100%;
  max-block-size: 100%;
  object-fit: contain;
  transform-origin: center;
  transition: transform var(--duration-ui) var(--ease-out);
  will-change: transform;
  -webkit-touch-callout: none;
}

.live {
  transition: none;
}

.step {
  position: absolute;
  inset-block-start: 50%;
  translate: 0 -50%;
}

.stepPrev {
  inset-inline-start: var(--space-2);
}

.stepNext {
  inset-inline-end: var(--space-2);
}

/* Touch screens swipe; the arrows are for mouse and keyboard. */
@media (hover: none) and (pointer: coarse) {
  .step {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .viewer {
    animation: none;
  }

  .photo {
    transition: none;
  }
}
